import * as PropTypes from "prop-types";
import SearchSvg from "./orange-user-icon.svg";
import Icon from "./Icon";

export default function UserIcon({ className, style }) {
  const localStyle = {
    minWidth: "1.2rem",
    minHeight: "1.2rem",
    ...style,
  };

  return <Icon src={SearchSvg} className={className} style={localStyle} />;
}

UserIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

UserIcon.defaultProps = {
  className: "",
  style: {},
};
